/* ==========================================================================
   Collection filtering & sorting: AJAX via the Section Rendering API,
   with graceful fallback to full-page form submission (the <form> still
   works if JS fails, since inputs carry proper name/value pairs).
   ========================================================================== */
(function () {
  'use strict';

  var form = document.querySelector('[data-facets-form]');
  if (!form) return;

  var panel = document.querySelector('[data-facets-panel]');
  var toggleButtons = document.querySelectorAll('[data-facets-toggle]');
  var collectionSection = document.querySelector('.collection-page[data-section-id]');
  var sectionId = collectionSection ? collectionSection.getAttribute('data-section-id') : null;

  toggleButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = panel.classList.toggle('is-open');
      panel.hidden = !isOpen;
      btn.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) theme.lockScroll();
      else theme.unlockScroll();
    });
  });

  document.addEventListener('theme:escape', function () {
    if (panel && panel.classList.contains('is-open')) {
      panel.classList.remove('is-open');
      panel.hidden = true;
      theme.unlockScroll();
    }
  });

  function currentFormUrl() {
    var params = new URLSearchParams(new FormData(form));
    // Drop empty params for a clean URL
    Array.from(params.keys()).forEach(function (key) {
      if (params.get(key) === '') params.delete(key);
    });
    return window.location.pathname + '?' + params.toString();
  }

  function fetchAndRender(url, pushState) {
    var targetSectionId = sectionId || 'main-collection';
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + targetSectionId;

    document.querySelector('[data-collection-results]') && document.querySelector('[data-collection-results]').setAttribute('aria-busy', 'true');

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        var newResults = temp.querySelector('[data-collection-results]');
        var oldResults = document.querySelector('[data-collection-results]');
        if (newResults && oldResults) oldResults.replaceWith(newResults);

        var newFacets = temp.querySelector('[data-facets]');
        var oldFacets = document.querySelector('[data-facets]');
        if (newFacets && oldFacets) {
          var wasOpen = oldFacets.querySelector('[data-facets-panel]').classList.contains('is-open');
          oldFacets.replaceWith(newFacets);
          if (wasOpen) {
            var reopened = document.querySelector('[data-facets-panel]');
            reopened.classList.add('is-open');
            reopened.hidden = false;
          }
        }

        var newPagination = temp.querySelector('.pagination');
        var oldPagination = document.querySelector('.pagination');
        if (oldPagination && newPagination) oldPagination.replaceWith(newPagination);
        else if (oldPagination && !newPagination) oldPagination.remove();

        if (pushState) window.history.pushState({}, '', url);
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  form.addEventListener(
    'change',
    theme.debounce(function (event) {
      if (!event.target.closest('[data-facet-checkbox], [data-sort-select], [data-facet-price-min], [data-facet-price-max]')) return;
      fetchAndRender(currentFormUrl(), true);
    }, 200)
  );

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    fetchAndRender(currentFormUrl(), true);
    if (panel) {
      panel.classList.remove('is-open');
      panel.hidden = true;
      theme.unlockScroll();
    }
  });

  document.addEventListener('click', function (event) {
    var clearBtn = event.target.closest('[data-facets-clear]');
    if (!clearBtn) return;
    form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
    form.querySelectorAll('input[type="number"]').forEach(function (input) { input.value = ''; });
    fetchAndRender(window.location.pathname, true);
  });

  window.addEventListener('popstate', function () {
    fetchAndRender(window.location.href, false);
  });
})();
